/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refund_No_PermissionInputs */

const vi_refund_no_permission = /** @type {(inputs: Refund_No_PermissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn chưa có quyền hoàn tiền. Phần khách trả thừa sẽ thành tiền dư của khách, trừ vào đơn sau hoặc để người có quyền hoàn sau.`)
};

/**

* @param {Refund_No_PermissionInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const refund_no_permission = /** @type {((inputs?: Refund_No_PermissionInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refund_No_PermissionInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_refund_no_permission(inputs)
});